<template>
  <div class="common-poup login-box">
    <h1 class="poup-title">石头网 · 登录</h1>
    <!-- <div class="login-tab-box">
          <span :class="[!currentIndex?'active':'']" @click="changeLoginType(0)">手机号登录</span>
          <span :class="[currentIndex?'active':'']" @click="changeLoginType(1)">账号登录</span>
    </div> -->
    <div class="form-wrapper-new form1">
          <template v-if="loginType === 'mobile'">
	    			  <div class="form-box user-box form-item">
						<input key="moblie-input" type="text" name="user" id="user" placeholder="请输入手机号" data-validate="mobile" v-model.trim="username" @keyup.enter="login"  autocomplete="off"/>
					  <div class="error-msg-box"></div>
						</div>
					  <div class="form-box password-box form-item">
						<input key="moblie-password" type="password" name="password" id="password"  placeholder="请输入登录密码" v-model.trim="password" @keyup.enter="login" />
					  <div class="error-msg-box"></div>
						</div>
					  <!-- <div class="form-box code-box form-item">
						<input key="moblie-code" type="text" name="code" id="code" maxlength="4" data-validate="imgcode" placeholder="输入验证码" v-model.trim="captcha" @keyup.enter="login" autocomplete="off"/>
						<div class="error-msg-box"></div>
						<span class="code-pic-box" @click="refreshCaptcha">
							<img :src="'data:image/jpg;base64,'+captchaUrl"/>
						</span>
					  </div> -->
					</template>
          <template v-else>
					   <div class="form-box accout-box form-item">
						<input key="username-input" type="text" name="user" id="user" placeholder="请输入登录账号"  v-model.trim="username" @keyup.enter="login"  autocomplete="off"/>
					  <div class="error-msg-box"></div>
						</div>
					  <div class="form-box password-box form-item">
						<input key="username-password" type="password" name="password" id="password" class="password-user" maxlength="20"  placeholder="请输入登录密码" @keyup.enter="login" v-model.trim="password" />
					 <div class="error-msg-box"></div>
					  </div>
					  <!-- <div class="form-box code-box form-item">
						<input key="username-code" type="text" name="code" id="code" maxlength="4" data-validate="imgcode" placeholder="输入验证码" v-model.trim="captcha" @keyup.enter="login" autocomplete="off"/>
						<div class="error-msg-box"></div>
						<span class="code-pic-box" @click="refreshCaptcha">
							<img :src="'data:image/jpg;base64,'+captchaUrl"/>
						</span>
					  </div> -->
					</template>
          <button class="login-btn" @click="login" :disabled="disabled">立即登录</button>
					<!-- <p class="tips-box" v-if="tipsIsShow">初始密码：888888，忘记账号或密码，请用<a href="javascript:;" @click="linkToPassword">手机找回</a>或者联系客服！</p> -->
          <p class="tips-box" v-if="tipsIsShow">初始密码：888888，忘记账号或密码，请联系客服！</p>
				</div>
			<div class="bottom-btn">
				<span @click="$emit('poupwhich','registerPoup');">注册</span>
				<span @click="showTips">忘记密码</span>
			</div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
		clearform:{
			type:Boolean
		}
	},
   data(){
    	return{
            loginType:'username', //用户名登录值为“username”，手机号登录值为“mobile
						// access_token:'',
						currentIndex:1,
						refresh_token:'',
						username:'',
						captcha :'',
						password:'',
						captchaUrl:'',
						flowId:'',
						disabled:false,
						mobileNumber:'',
						tipsIsShow:false
        };
		},
	watch:{
    clearform:function(v,n){
			if (v!=n) {
				this.username='';
				this.password='';
				if (	$('div.error-msg-box').hasClass('error-msg-show')) {
					$('div.error-msg-box').removeClass('error-msg-show');
				}
				this.tipsIsShow=false;
			}
		}
	},
  components:{},
  created: function() {},
	mounted: function() {
		// this.getCaptcha();
	},
	methods: {
		changeLoginType:function(index){
			this.captcha ='';
			this.username='';
			this.password='';
			this.$options.methods.getCaptcha(this);
			this.currentIndex=index;
			$('div.error-msg-box').removeClass('error-msg-show');
			if (index) {
				this.loginType='username';
			} else{
				this.loginType='mobile';
			}
		},
		getCaptcha: function($this) {
			var _this = $this?$this:this;
			var opts = {
				isLoading: true,
				loadingDom: '',
				success: function(result) {
					_this.captchaUrl=result.content.captcha;
					_this.flowId=result.content.flowId;
				}
			};
			_this.getAjaxCommon(accountBaseUrl+'/account/captcha','get','', opts);
		},
		refreshCaptcha:function(){
			this.$options.methods.getCaptcha(this);
		},
		loginRequest:function($this){
			var _this = $this?$this:this;
			var data={
				// loginType:_this.loginType,
				username:_this.username,
				// captcha :_this.captcha,
				password:_this.password,
				flowId:_this.flowId
			};
			var opts = {
				isLoading: true,
				loadingDom: '',
				success: function(result) {
					_this.cookies().del('last_login_time');
					_this.cookies().del('saveEmail');
					_this.cookies().del('mobile');
					_this.cookies().del('username');
					_this.cookies().del('access_token');
					_this.cookies().del('refresh_token');
					_this.cookies().del('login_type');
					_this.cookies().del('id');
					_this.cookies().del('mobileAuthLocked');
					_this.loginType=result.content.loginType;
					_this.cookies().write('access_token', result.content.access_token, 7);
					_this.cookies().write('refresh_token', result.content.refresh_token, 7);
					_this.cookies().write('login_type',_this.loginType, 7);
					if (_this.loginType==='mobile') {
						_this.cookies().write('mobile',_this.username, 7);
					} else if (_this.loginType==='username'){
						_this.cookies().write('username',_this.username, 7);
					}

					_this.$emit('poupwhich',''); //hide loginPoup
						// 通知top去获取用户信息
					_this.$emit('getuserinfo');
				},
				error:function(result){
					_this.disabled=false;
					_this.captcha ='';
					_this.username='';
					_this.password='';
				  //  _this.$options.methods.getCaptcha(_this);
					// _this.$message({
					// 	showClose: true,
					// 	message: result.message,
					// 	type: 'warning'
					// });
					_this.$layer.msg(result.message);
				}
			};
			// _this.getAjaxCommon(accountBaseUrl+'/account/login','post',data,opts);
			_this.getAjaxCommon(accountBaseUrl+'/account/login/usernameAndMobile','post',data,opts);
		},
		login:function(){
			var isValidate=doValidate('div.form-wrapper-new');
			if (isValidate) {
				this.disabled=true;
				this.$options.methods.loginRequest(this);
			}
		},
		linkToPassword:function(){
			window.location.href='/personalCenter/editPassword.html'
		},
		showTips:function(){
			this.tipsIsShow=true;
		}
	}
};
</script>
<style lang="scss"  scoped="scoped">
@import "~scss/mixin";
@import "~scss/poup";
* {
		margin: 0;
		padding: 0;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		-ms-tap-highlight-color: rgba(0, 0, 0, 0);
		tap-highlight-color: rgba(0, 0, 0, 0);
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
		-ms-text-size-adjust: 100%;
		-webkit-text-size-adjust: 100%;
}
div.login-box{
    width:446px;
		// height:564px;
		height:400px;
    h1.poup-title{
        background:url(~images/login_title.png) no-repeat 10px 10px;
        text-indent:-9999px;
        margin-bottom:42px;
        height: 40px;
		}
		div.login-tab-box{
        height: 40px;
        line-height: 40px;
        margin-bottom: 84px;
        text-align: center;
        font-size: 20px;
        @include clearboth;
        span{
            color: $color-text;
            display: inline-block;
            width: 50%;
            height: 100%;
            float: left;
            cursor: pointer;
            position: relative;
            z-index: 1;
            &.active{
                font-weight: bold;
                color: $hover-color;
                &:after{
                    display: block;
                    content: '';
                    width: 30px;
                    height: 0;
                    position: absolute;
                    left: 50%;
                    margin-left: -15px;
                    bottom: -4px;
                    border-bottom:2px solid $red-color;
                }
            }
        }
    }
		div.form-wrapper-new{
			div.code-box{
				>input{
					padding-right:140px;
				}
				span {
						display: block;
						width: 110px;
						height: 46px;
						line-height: 46px;
						position: absolute;
						right: 0;
						top: 0;
						text-align: center;
						color: #333;
						cursor: pointer;
						&.code-pic-box {
                img {
                  width: 88%;
                  vertical-align: middle;
                }
            }
				}
			}
			p.tips-box{
				a{
					color: $hover-color;
					text-decoration: underline;
				}
			}
		}

}

</style>



// WEBPACK FOOTER //
// src/components/loginPoup.vue